import { useEffect } from 'react';

import { REDIRECT_BAD_STATUS_PAGE } from '~common/constants';
import { RentalFailedReason } from '~common/enum';
import { useNavigateInApp } from '~hooks/index';
import { useStationInformationContext } from '~providers';
import { StationBatteryAvailability, StationStatus } from '~types/station.type';

export const useUnavailableBatteriesEffect = () => {
  const { batteryAvailability } = useStationInformationContext();
  const navigate = useNavigateInApp();

  useEffect(() => {
    if (
      batteryAvailability === StationBatteryAvailability.NO_BATTERIES_AVAILABLE
    ) {
      navigate(
        REDIRECT_BAD_STATUS_PAGE[RentalFailedReason.NO_RENTABLE_BATTERY],
      );
    } else if (
      batteryAvailability === StationBatteryAvailability.ALL_BATTERIES_CHARGING
    ) {
      navigate(REDIRECT_BAD_STATUS_PAGE[StationStatus.RECHARGING]);
    }
  }, [batteryAvailability, navigate]);
};
